import { useState } from "react";
import { api } from "../lib/api";

export const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.subscribeNewsletter({ email });
      setStatus({ type: "success", message: "Welcome to the list." });
      setEmail("");
    } catch (err) {
      setStatus({ type: "error", message: err.response?.data?.detail || "Something went wrong" });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email"
        required
        data-testid="newsletter-email"
        className="input-on-orange flex-1 px-4 py-3 text-sm rounded-md"
      />
      <button type="submit" data-testid="newsletter-submit" className="btn-dark px-6 py-3 text-sm font-medium rounded-md">
        Subscribe
      </button>
      {status.message && (
        <p className={`text-sm mt-2 ${status.type === "success" ? "text-[#2D1810]" : "text-red-800"}`}>
          {status.message}
        </p>
      )}
    </form>
  );
};
